import { Link2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4c-1-1.6-1.5-3.4-1.5-5.2 0-5.4 4.4-9.8 9.8-9.8 2.6 0 5.1 1 6.9 2.9 1.8 1.8 2.9 4.3 2.9 6.9 0 5.4-4.4 9.8-9.8 9.8zm8.4-18.2C18.1 1.3 15.2 0 12 0 5.4 0 .1 5.3.1 11.9c0 2.1.6 4.1 1.6 5.9L0 24l6.3-1.7c1.7.9 3.7 1.4 5.7 1.4 6.6 0 11.9-5.3 11.9-11.9 0-3.2-1.2-6.2-3.5-8.4z" />
  </svg>
);

export function ShareBrand({ brand }) {
  const url = `${API}/share/brands/${brand.slug}`;
  const text = `${brand.name} price lists on PRICEHUB — download PDF & Excel: ${url}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied", { description: "It shows a branded preview when shared." }); }
    catch { toast.error("Could not copy the link"); }
  };
  const native = async () => {
    try { await navigator.share({ title: `${brand.name} price lists | PRICEHUB`, url }); } catch { /* cancelled */ }
  };
  const btn = "inline-flex h-11 items-center gap-2 rounded-full border px-4 text-sm font-semibold transition-[background-color,transform] duration-300 hover:-translate-y-0.5";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-brand">
      <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer" data-testid="share-whatsapp-btn"
        className={`${btn} border-[#25D366]/40 bg-[#25D366]/10 text-ph-ink hover:bg-[#25D366]/20`}>
        <WhatsAppIcon /> Share on WhatsApp
      </a>
      <button type="button" onClick={copy} data-testid="share-copy-btn" className={`${btn} border-ph-line bg-ph-surface text-ph-ink hover:bg-ph-raised`}>
        <Link2 className="h-4 w-4" /> Copy link
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button type="button" onClick={native} data-testid="share-native-btn" aria-label="More sharing options" className={`${btn} border-ph-line bg-ph-surface text-ph-ink hover:bg-ph-raised`}>
          <Share2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
